<template>
  <div class="badge" :class="[{'badge_office': categoryProps === config.rootcategories.biuro}, getClass()]" v-if="showBadge()">
    <span>{{ $t(getTextLabel()) }}</span>
  </div>
</template>

<script>
import config from 'config'

export default {
  data () {
    return {
      config
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    }
  },
  methods: {
    showBadge () {
      if (this.product.is_promotion && !this.product.is_tradeoff) {
        return true;
      } else if (this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return true;
      } else if (this.product.is_suggested && !this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return true;
      } else if (this.product.is_tradeoff) {
        return true;
      } else if (this.product.is_tradeoff) {
        return true;
      }
      return false;
    },
    getClass () {
      if (this.product.is_promotion && !this.product.is_tradeoff) {
        return this.categoryProps !== config.rootcategories.biuro ? 'badge--promotion' : 'badge--promotion-office';
      } else if (this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return  this.categoryProps !== config.rootcategories.biuro ? 'badge--novelty' : 'badge--novelty-office';
      } else if (this.product.is_suggested && !this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return this.categoryProps !== config.rootcategories.biuro ? 'badge--top' : 'badge--top-office';
      } else if (this.product.is_tradeoff) {
        return this.categoryProps !== config.rootcategories.biuro ? 'badge--sale' : null;
      } 
    },
    getTextLabel () {
      if (this.product.is_promotion && !this.product.is_tradeoff) {
        return 'Promotion';
      } else if (this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return 'Novelty';
      } else if (this.product.is_suggested && !this.product.is_new_product && !this.product.is_promotion && !this.product.is_tradeoff) {
        return 'Top';
      } else if (this.product.is_tradeoff) {
        return 'Sale'
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';

.badge {
  position: absolute;
  top: 8px;
  right: 34px;
  padding: 0 8px;
  border-radius: 22px;
  box-sizing: border-box;
  font-size: 11px;
  color: #ffffff;
  width: 65px;
  text-align: center;
  text-transform: uppercase;
  height: 34px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  opacity: 1;
  z-index: 1;

  &--promotion {
    background: #f20472;
  }
  &--top {
    background: #2a0064;
  }
  &--novelty {
    background: #7bcaed;
  }
  &--sale {
    background: #edd326;
  }
  &--promotion-office {
    background: $office-promotion;
  }
  &--top-office {
    background: $office-primary;
  }
  &--novelty-office {
    background: $office-secondary;
  }
}

@media(max-width: 768px) {
  .badge_office {
    top: unset;
  }
}


</style>